var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.87 24.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.98,21.57C-2.9,15.24-.49,3.81,8.28.72c9.34-3.29,18.59,5.16,16.2,14.75-2.27,9.12-13.54,12.49-20.5,6.1ZM12.36,1.62C3.98,1.65-1.23,10.9,3.18,18.1c4.16,6.81,14.06,6.92,18.36.19,4.62-7.23-.64-16.7-9.17-16.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.56,6.02c.81,0,1.77-.06,2.54.16,1.44.4,2.53,1.7,2.72,3.18-.02,1.92.13,3.94.03,5.85-.11,1.97-1.66,3.55-3.64,3.66-1.83-.08-3.74.1-5.56,0-2.06-.12-3.63-1.77-3.66-3.83.06-1.71-.08-3.48,0-5.18.09-1.94,1.46-3.69,3.48-3.83,1.28-.08,2.78-.01,4.09-.02h0ZM9.56,7.31c-1.19.13-2.2,1.17-2.28,2.37-.12,1.82.09,3.77,0,5.61.14,1.17,1.04,2.1,2.19,2.29,1.83-.03,3.81.16,5.63.03,1.35-.09,2.39-1.14,2.48-2.48-.08-1.75.11-3.6,0-5.34-.08-1.27-1.02-2.32-2.3-2.48h-5.73.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.15,9.24c3.25-.29,4.77,3.79,2.17,5.66-2.02,1.46-4.83.05-4.96-2.41-.08-1.59,1.19-3.11,2.79-3.25h0ZM11.09,10.94c-.97.97-.68,2.66.57,3.24,1.55.71,3.22-.71,2.76-2.36-.4-1.45-2.27-1.94-3.33-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.72,8.28c1.03-.11,1.13,1.42.15,1.5s-1.1-1.4-.15-1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.70aec1fc81b7c11169fb77ff3e1f19f0.svg";
export { ForwardRef as ReactComponent };